import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "terms-and-conditions" }
const _hoisted_2 = { class: "section-title large" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "terms-content" }
const _hoisted_5 = { class: "content-section intro-section" }
const _hoisted_6 = { class: "section-badge" }
const _hoisted_7 = { class: "intro-text" }
const _hoisted_8 = { class: "content-section" }
const _hoisted_9 = { class: "section-badge" }
const _hoisted_10 = { class: "markets-grid" }
const _hoisted_11 = { class: "market-card-header" }
const _hoisted_12 = { class: "market-icon" }
const _hoisted_13 = { class: "market-title" }
const _hoisted_14 = { class: "market-content" }
const _hoisted_15 = { class: "market-name" }
const _hoisted_16 = { class: "market-description" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "content-section rules-section" }
const _hoisted_19 = { class: "section-badge" }
const _hoisted_20 = { class: "rules-list" }
const _hoisted_21 = { class: "rule-number" }
const _hoisted_22 = { class: "rule-content" }
const _hoisted_23 = { class: "rule-title" }



export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TermsAndConditionsView'
},
  __name: 'TermsAndConditionsView',
  setup(__props) {



const markets = [
  ['📊', 'sumOddEven'],
  ['⚖️', 'sumOverUnder'],
  ['🎯', 'sumWithinRange'],
  ['⭐', 'bonusBallOddEven'],
  ['✨', 'sumBonusBallsOddEven'],
  ['📈', 'bonusBallOverUnder'],
  ['📉', 'sumBonusBallsOverUnder'],
  ['🔢', 'bonusBallSingleDigit'],
  ['🔗', 'bonusBallMatchesRegular'],
  ['🎲', 'bonusBallWithinRange'],
  ['➕', 'combinedTotalOverUnder'],
  ['🎯', 'standardBetNoBonus'],
  ['⭐', 'standardBetSameDrum'],
  ['🎪', 'standardBetAdditionalDrum'],
  ['🎲', 'bonusBetSameDrum'],
  ['🎰', 'bonusBetDifferentDrum'],
  ['🎯', 'regularPlusBonusSameDrum'],
  ['🎪', 'ballNotToFall'],
  ['📊', 'bonusBallColor', true]
].map(([icon, key, colors]) => ({
  icon,
  title: `terms.${key}`,
  name: `terms.${key}Name`,
  description: `terms.${key}Desc`,
  colors: Boolean(colors)
}))

const colorRules = [
  { key: 'terms.colorGreen', numbers: '(1, 8, 15, 22, 29, 36, 43)' },
  { key: 'terms.colorRed', numbers: '(2, 9, 16, 23, 30, 37, 44)' },
  { key: 'terms.colorOrange', numbers: '(3, 10, 17, 24, 31, 38, 45)' },
  { key: 'terms.colorYellow', numbers: '(4, 11, 18, 25, 32, 39, 46)' },
  { key: 'terms.colorBrown', numbers: '(5, 12, 19, 26, 33, 40, 47)' },
  { key: 'terms.colorPurple', numbers: '(6, 13, 20, 27, 34, 41, 48)' },
  { key: 'terms.colorBlue', numbers: '(7, 14, 21, 28, 35, 42, 49)' }
]

const rules = Array.from({ length: 10 }, (_, index) => ({
  title: `terms.rule${index + 1}Title`,
  text: `terms.rule${index + 1}Text`
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('terms.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('terms.subtitle')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('terms.aboutNumbersBetting')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('terms.introText')), 1)
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('terms.availableMarkets')), 1),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(markets), (market) => {
            return (_openBlock(), _createElementBlock("div", {
              key: market.title,
              class: "market-card"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(market.icon), 1),
                _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t(market.title)), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(market.name)), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(market.description)), 1),
                  (market.colors)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colorRules, (color) => {
                          return _createElementVNode("li", {
                            key: color.key
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t(color.key)) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(color.numbers), 1)
                          ])
                        }), 64))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('terms.importantRules')), 1),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rules), (rule, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: rule.title,
              class: "rule-card"
            }, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(index + 1), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t(rule.title)), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(rule.text)), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})